"use client"
import { useTheme } from "@/contexts/themeContext/themeContext";
import StyledComponentsRegistry from "@/lib/antd-registry";
import { ConfigProvider } from "antd";
import EnhancedCookieConsent from "../consent/consent";

const ThemedApp = ({ children }: { children: React.ReactNode }) => {
  const { themeConfig, themeConfigColors, mode } = useTheme();

  return (
   <>
      <EnhancedCookieConsent />

      <StyledComponentsRegistry>
        <ConfigProvider theme={themeConfig}>{children}</ConfigProvider>
      </StyledComponentsRegistry>
   </>
    
  );
};
export default ThemedApp;